module.exports = __webpack_public_path__ + "static/media/Skills4ESG_white.c4b47b0b.png";